import { BrowserRouter, Route, Routes } from 'react-router';
import { Provider } from 'react-redux';
import { LoginPage } from '@/pages';
import { Header, Sidebar, MainContent } from '@/components';
import { Stack } from '@data-products-and-ai/react-components';
import { store } from '@/store';

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';

import '@/App.scss';

const LoginToggle = () => {
  return (
    <div className="app">
      <AuthenticatedTemplate>
        <Header />
        <Stack direction="row">
          <Sidebar />
          <MainContent />
        </Stack>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Routes>
          <Route path="*" element={<LoginToggle />} />
        </Routes>
      </Provider>
    </BrowserRouter>
  );
};

export default App;
